<template>
  <div class="procesos-container">
    <!-- Unified Container -->
    <div class="unified-container">
      <!-- Header Section -->
      <div class="header-section">
        <div class="title-section">
          <v-icon class="title-icon" color="white">mdi-responsive</v-icon>
          <div class="title-text">
            <h1 class="main-title">DIRECTOR DE ÁREA</h1>
            <p class="subtitle">Gestión de procesos de compra</p>
          </div>
        </div>
        <div class="header-actions">
          <v-btn
            class="export-btn"
            @click="downloadExcel"
            elevation="0"
            rounded
          >
            <v-icon left>mdi-file-excel</v-icon>
            EXPORTAR EXCEL
          </v-btn>
        </div>
      </div>
      <!-- Search Section -->
      <div class="search-section">
        <div class="search-card">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar Aplicación"
            solo
            flat
            hide-details
            class="search-field"
          ></v-text-field>
        </div>
        <div class="create-btn-container">
          <v-btn
            class="create-btn"
            @click="dialog = true"
            elevation="0"
            rounded
            large
          >
            <v-icon left>mdi-plus-thick</v-icon>
            CREAR PROCESO
          </v-btn>
        </div>
      </div>

      <!-- Dialog para crear proceso -->
      <v-dialog
        v-model="dialog"
        max-width="70rem"
        persistent
        :overlay="true"
        overlay-color="black"
        overlay-opacity="0.8"
        overlay-class="scrim-opaco-crear"
      >
        <v-card>
          <v-card-title class="nav">
            <span class="headline" style="color: white">
              <v-icon color="white">mdi-application-edit</v-icon>
              {{ formTitle }}
            </span>
          </v-card-title>
          <!-- componente del modal para agregar y actualizar -->
          <v-card-text>
            <v-container grid-list-md>
              <v-row>
                <v-col cols="7" style="min-height: 600px">
                  <v-card
                    elevation="6"
                    class="pa-6"
                    style="
                      background: #f7f9fa;
                      border-radius: 18px;
                      box-shadow: 0 4px 24px #e0e0e055;
                    "
                  >
                    <div
                      class="font-weight-bold mb-6 text-center"
                      style="
                        font-size: 22px;
                        letter-spacing: 1px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        gap: 10px;
                      "
                    >
                      <v-icon color="primary">mdi-pencil-box-multiple</v-icon>
                      Formulario de proceso
                    </div>
                    <v-row>
                      <v-col cols="6">
                        <v-text-field
                          v-model="editedItem.concepto"
                          label="Concepto"
                          maxlength="80"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6">
                        <v-text-field
                          v-model="editedItem.cantidad"
                          label="Cantidad"
                          @input="formatearNumero('cantidad', $event)"
                          @keypress="soloNumerosCantidad"
                          type="text"
                          placeholder="0"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6">
                        <v-text-field
                          v-model="editedItem.presupuesto"
                          label="Presupuesto"
                          maxlength="80"
                          @input="formatearNumero('presupuesto', $event)"
                          @keypress="soloNumerosConDecimales"
                          type="text"
                          placeholder="0"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6">
                        <v-menu
                          ref="menu"
                          v-model="menu"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                          max-width="290px"
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="editedItem.fecha"
                              label="Fecha requerida"
                              prepend-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              @click:prepend="menu = !menu"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="editedItem.fecha"
                            no-title
                            scrollable
                            @input="menu = false"
                          >
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="menu = false"
                              >Cancelar</v-btn
                            >
                            <v-btn text color="primary" @click="menu = false"
                              >OK</v-btn
                            >
                          </v-date-picker>
                        </v-menu>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-select
                          v-model="editedItem.empresa"
                          :items="['Facilísimo', 'Apostar']"
                          label="Empresa"
                          single-line
                          return-object
                          :disabled="empresaFija !== ''"
                        ></v-select>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-text-field
                          v-model="editedItem.expecificaciones"
                          label="Detalle técnico"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-text-field
                          v-model="editedItem.observaciones"
                          label="Observaciones"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-text-field
                          v-model="editedItem.asunto"
                          label="Asunto"
                          maxlength="50"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-file-input
                          v-model="selectedFile"
                          label="Adjuntar archivos (máx. 5)"
                          accept=".jpg,.jpeg,.png,.gif,.pdf,.doc,.docx"
                          multiple
                          :counter="5"
                          :show-size="true"
                          :rules="[
                            (files) =>
                              !files ||
                              files.length <= 5 ||
                              'Máximo 5 archivos',
                          ]"
                          class="mr-3"
                          :disabled="selectedFile && selectedFile.length > 0"
                        ></v-file-input>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
                <v-col cols="5" style="min-height: 600px">
                  <v-card
                    elevation="6"
                    class="pa-4"
                    style="
                      background: #fafbfc;
                      border-radius: 16px;
                      min-height: 400px;
                      border: 1px solid #e0e0e0;
                    "
                  >
                    <div
                      class="font-weight-bold mb-4 text-center"
                      style="
                        font-size: 20px;
                        letter-spacing: 1px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        gap: 8px;
                      "
                    >
                      <v-icon color="primary">mdi-format-list-bulleted</v-icon>
                      Procesos agregados
                    </div>
                    <v-list v-if="apps1.length" class="pa-0">
                      <v-list-item
                        v-for="(proceso, idx) in apps1"
                        :key="idx"
                        class="mb-3"
                        style="
                          border-radius: 10px;
                          border: 1px solid #e0e0e0;
                          background: #fff;
                          box-shadow: 0 2px 8px #e0e0e033;
                        "
                      >
                        <v-list-item-content>
                          <v-list-item-title
                            class="font-weight-bold"
                            style="font-size: 17px"
                            >{{ proceso.concepto }}
                            <span class="blue--text">
                              - {{ proceso.empresa }}</span
                            ></v-list-item-title
                          >
                          <v-list-item-subtitle style="font-size: 15px"
                            >Cantidad: <b>{{ proceso.cantidad }}</b> |
                            Presupuesto:
                            <b>{{
                              proceso.presupuesto
                            }}</b></v-list-item-subtitle
                          >
                          <v-list-item-subtitle style="font-size: 14px">
                            Fecha:
                            <b>{{ proceso.fecha }}</b></v-list-item-subtitle
                          >
                          <v-list-item-subtitle
                            style="font-size: 14px"
                            class="mt-1"
                            >Detalle técnico:
                            <span class="grey--text">{{
                              proceso.expecificaciones
                            }}</span></v-list-item-subtitle
                          >
                          <v-list-item-subtitle style="font-size: 14px"
                            >Observaciones:
                            <span class="grey--text">{{
                              proceso.observaciones
                            }}</span></v-list-item-subtitle
                          >
                          <v-list-item-subtitle style="font-size: 14px"
                            >Asunto:
                            <span class="grey--text">{{
                              proceso.asunto
                            }}</span></v-list-item-subtitle
                          >
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-btn icon @click="apps1.splice(idx, 1)"
                            ><v-icon color="error">mdi-delete</v-icon></v-btn
                          >
                        </v-list-item-action>
                      </v-list-item>
                    </v-list>
                    <div
                      v-else
                      class="grey--text text--darken-1 mt-5 text-center"
                      style="font-size: 18px"
                    >
                      No hay procesos agregados aún.
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <!-- botones para cancelar y agregregar y validacion de campos vacios -->
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn elevation="2" color="#FF2E2E" @click="close">Cancelar</v-btn>
            <v-btn
              color="primary"
              @click="cargarProcesoYContinuar()"
              :disabled="
                !editedItem.concepto ||
                !editedItem.cantidad ||
                editedItem.cantidad < 1 ||
                !editedItem.presupuesto ||
                !editedItem.fecha ||
                !editedItem.empresa
              "
              >Agregar proceso</v-btn
            >
            <v-btn
              color="#00CC00"
              @click="cargartabla()"
              :disabled="apps1.length === 0"
              >Guardar todos</v-btn
            >
          </v-card-actions>
          <!-- <pre>{{editedItem}}</pre>  -->
        </v-card>
      </v-dialog>

      <!-- Dialog para agregar observación -->
      <v-dialog
        v-model="dialogObservacion"
        max-width="500px"
        persistent
        :overlay="true"
        overlay-color="black"
        overlay-opacity="0.8"
      >
        <v-card>
          <v-card-title class="nav">
            <span class="headline" style="color: white">
              <v-icon color="white">mdi-comment-plus</v-icon>
              Agregar Observación
            </span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-textarea
                    v-model="nuevaObservacion"
                    label="Observación"
                    placeholder="Escribe tu observación aquí..."
                    rows="4"
                    counter="500"
                    maxlength="500"
                    outlined
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn elevation="2" color="#f7e506" @click="cerrarObservacion">
              Cancelar
            </v-btn>
            <v-btn
              color="#f7e506"
              @click="guardarObservacion"
              :disabled="!nuevaObservacion || nuevaObservacion.trim() === ''"
            >
              Guardar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Table Section -->
      <div class="table-section">
        <div class="table-card">
          <v-data-table
            :headers="headers"
            :items="apps"
            :search="search"
            class="modern-table"
            :items-per-page="10"
            :footer-props="{
              'items-per-page-options': [10, 20, 50],
              'items-per-page-text': 'Filas por página:',
            }"
          >
            <template v-slot:no-data>
              <v-alert
                :value="true"
                color="#F44336"
                icon="mdi-alert"
                outlined
                type="warning"
                prominent
                border="left"
              >
                <strong>No</strong> se encontro su busqueda
              </v-alert>
            </template>
            <!--acciones de los datos obtenidos del arreglo-->
            <template v-slot:[`item.actions`]="{ item }">
              <div class="action-icons">
                <v-icon
                  class="action-icon view-icon"
                  @click="pdfProcesos(item)"
                  title="Ver archivos"
                >
                  mdi-eye
                </v-icon>

                <div
                  v-if="item.estado === '7' || item.estado === '6'"
                  class="action-group"
                >
                  <v-icon
                    class="action-icon approve-icon"
                    @click="marcarCompraRealizada(item)"
                    :disabled="item.loading"
                    title="Marcar compra realizada"
                  >
                    mdi-check-bold
                  </v-icon>
                </div>
                <div class="action-group">
                  <v-icon
                    class="action-icon comment-icon"
                    @click="agregarObservacion(item)"
                    title="Agregar observación"
                  >
                    mdi-comment-plus
                  </v-icon>
                </div>
              </div>
            </template>
            <template v-slot:[`item.procesos`]="{ item }">
              <v-icon
                class="pdf-icon"
                @click="pdfProcesos(item)"
                title="Ver PDF"
              >
                mdi-file-pdf-box
              </v-icon>
            </template>
            <template v-slot:[`item.archivo`]="{ item }">
              <v-icon
                v-if="item.ruta_img"
                class="view-icon"
                @click="verArchivos(item)"
                title="Ver archivo"
              >
                mdi-eye
              </v-icon>
            </template>
            <template v-slot:[`item.estado`]="{ item }">
              <div v-if="item.estado === '0'">
                <v-chip outlined class="ma-2" color="red"> CANCELADO </v-chip>
              </div>
              <div v-if="item.estado === '1'">
                <v-chip outlined class="ma-2" color="orange darken-2">
                  GERENTE
                </v-chip>
              </div>
              <div v-if="item.estado === '3' || item.estado === '2'">
                <v-chip outlined class="ma-2" color="amber accent-4">
                  COMPRAS
                </v-chip>
              </div>
              <div v-if="item.estado === '5'">
                <v-chip outlined class="ma-2" color="green darken-4">
                  DIRECCION FINANCIERA
                </v-chip>
              </div>
              <div v-if="item.estado === '4'">
                <v-chip outlined class="ma-2" color="green">
                  APROBACION DIRECTOR AREA
                </v-chip>
              </div>
              <div v-if="item.estado === '6'">
                <v-chip outlined class="ma-2" color="green">
                  APROBACION GERENTE
                </v-chip>
              </div>
              <div v-if="item.estado === '7'">
                <v-chip outlined color="green">REALIZAR COMPRA</v-chip>
              </div>
              <div v-if="item.estado === '8'">
                <v-chip outlined class="ma-2" color="green">
                  COMPRA REALIZADA
                </v-chip>
              </div>
            </template>
          </v-data-table>
        </div>
      </div>

     <!-- Second Table Section -->
     <div class="table-section">
        <div class="table-card">
          <v-data-table
            :headers="headers1"
            :items="apps1"
            :items-per-page="5"
            class="modern-table"
          >
            <template v-slot:no-data>
              <v-alert
                :value="true"
                color="#E57373"
                icon="mdi-alert"
                outlined
                type="warning"
                prominent
                border="left"
              >
                <strong> No </strong> hay información para mostrar aun
              </v-alert>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <div class="action-icons">
                <div v-if="item.actions === '0'" class="action-group">
                  <v-icon
                    class="action-icon edit-icon"
                    @click="editItem(item)"
                    title="Editar"
                  >
                    mdi-pencil
                  </v-icon>
                </div>
                <div class="action-group">
                  <v-icon
                    class="action-icon delete-icon"
                    @click="deleteItem(item)"
                    title="Eliminar"
                  >
                    mdi-delete
                  </v-icon>
                </div>
              </div>
            </template>
          </v-data-table>
        </div>
      </div>

      <!-- Send Button Section -->
      <div class="send-section">
        <v-btn
          class="send-btn"
          :disabled="!estadoTabla == true"
          @click="Enviar()"
          elevation="0"
          rounded
          large
        >
          ENVIAR TODO
          <v-icon right>mdi-send</v-icon>
        </v-btn>
      </div>
      <v-dialog
        v-model="dialogPdf"
        persistent
        :overlay="true"
        max-width="60rem"
        overlay-color="black"
        overlay-opacity="0.8"
      >
        <v-card style="max-width: 900px; width: 100%">
          <v-card-title class="nav">
            <span class="headline" style="color: white"
              ><v-icon color="white">mdi-clipboard-edit-outline</v-icon>
              Editar Proceso
            </span>
          </v-card-title>
          <!-- componente del modal para agregar y actualizar -->
          <v-card-text>
            <v-container grid-list-md>
              <v-layout
                v-for="(item, index) in editedItem.infoProceso"
                :key="index"
              >
                <v-card class="mt-5" width="98%" elevation="4">
                  <v-layout wrap class="pl-7 pt-4 pr-7">
                    <v-flex xs6 sm6 md6>
                      <v-text-field
                        v-model="item.concepto"
                        label="Concepto"
                        disabled
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs6 sm6 md6>
                      <v-text-field
                        v-model="item.cantidad"
                        type="number"
                        min="0"
                        label="Cantidad"
                        disabled
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs6 sm6 md6>
                      <v-text-field
                        v-model="item.presupuesto"
                        type="number"
                        min="0"
                        label="Presupuesto"
                        disabled
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs6 sm6 md6>
                      <v-text-field
                        v-model="item.fecha"
                        type="date"
                        min="0"
                        label="Fecha"
                        disabled
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 md12>
                      <v-text-field
                        v-model="item.empresa"
                        label="Empresa"
                        single-line
                        return-object
                        disabled
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 md12>
                      <v-textarea
                        v-model="item.expecificaciones"
                        label="Detalle técnico"
                        disabled
                      ></v-textarea>
                    </v-flex>
                    <v-flex xs12 sm12 md12>
                      <v-textarea
                        v-model="item.observaciones"
                        label="Observaciones"
                        disabled
                      ></v-textarea>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-layout>
              <!-- <pre>{{editedItem}}</pre> -->
            </v-container>
          </v-card-text>
          <!-- botones para cancelar y agregregar y validacion de campos vacios -->
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn elevation="2" color="#f7e506" @click="close">Cerrar</v-btn>
          </v-card-actions>
          <!-- <pre>{{editedItem}}</pre>  -->
        </v-card>
      </v-dialog>

      <!-- Snackbar para notificaciones -->
      <v-snackbar
        v-model="snackbar"
        :bottom="y === 'bottom'"
        :left="x === 'left'"
        :multi-line="mode === 'multi-line'"
        :right="x === 'right'"
        :timeout="timeout"
        :top="y === 'top'"
        :vertical="mode === 'vertical'"
        color="#3b82f6"
        class="modern-snackbar"
      >
        {{ text }}
        <v-btn color="white" text @click="snackbar = false"> Cerrar </v-btn>
      </v-snackbar>

      <!-- Dialog para ver archivos adjuntos -->
      <v-dialog
        v-model="dialogArchivos"
        persistent
        :overlay="true"
        max-width="900px"
        overlay-color="black"
        overlay-opacity="0.8"
      >
        <v-card>
          <v-card-title class="headline">Archivos Adjuntos</v-card-title>
          <v-card-text>
            <v-row>
              <v-col
                v-for="(archivo, idx) in archivosModal"
                :key="idx"
                cols="12"
                sm="6"
                md="4"
                lg="3"
                class="d-flex flex-column align-center"
              >
                <div
                  v-if="esImagen(archivo)"
                  class="archivo-preview-modal-director"
                  @click="abrirArchivo(archivo)"
                >
                  <v-img :src="archivo" contain height="100%" width="100%" />
                </div>
                <div
                  v-else
                  class="archivo-preview-modal-director d-flex flex-column align-center justify-center"
                  @click="abrirArchivo(archivo)"
                >
                  <v-icon color="primary" size="60">mdi-file-document</v-icon>
                  <span
                    class="mt-2 text-center"
                    style="font-size: 13px; word-break: break-all"
                    >{{ nombreArchivo(archivo) }}</span
                  >
                </div>
                <div
                  v-if="esImagen(archivo)"
                  class="mt-2 text-center"
                  style="
                    font-size: 13px;
                    word-break: break-all;
                    max-width: 180px;
                  "
                >
                  {{ nombreArchivo(archivo) }}
                </div>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="dialogArchivos = false"
              >Cerrar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import env from "../env";
import swal from "sweetalert";
import XLSX from "xlsx";
export default {
  data() {
    return {
      show: false,
      snackbar: false,
      y: "top",
      x: null,
      mode: "",
      timeout: 6000,
      text: "",
      search: "",
      apps: [],
      apps1: [],
      empresaFija: "",
      menu: false, // Para el date picker
      rules: {
        required: (value) => !!value || "Required.",
        counter: (value) => value.length <= 20 || "Maximo 20 characteres",
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalido e-mail.";
        },
      },
      dialog: false,
      dialogPdf: false,
      dialogObservacion: false,
      dialogArchivos: false,
      nuevaObservacion: "",
      procesoSeleccionado: null,
      loader: true,
      loading: false,
      envia: true,
      contadorTabla: 0,
      estadoTabla: false,
      selectedFile: [],
      getFile: null,
      archivosModal: [],
      headers: [
        {
          text: "ID",
          value: "idProceso",
          align: "center",
          class: "column",
        },
        {
          text: "Concepto",
          value: "infofrase",
          align: "center",
          class: "column",
        },
        {
          text: "Empresa",
          value: "empresa",
          align: "center",
          class: "column",
        },
        {
          text: "Procesos",
          value: "procesos",
          align: "center",
          class: "column",
        },
        {
          text: "Fecha",
          value: "fechaCreacion",
          align: "center",
          class: "column",
        },
        {
          text: "Estado",
          value: "estado",
          align: "center",
          class: "column",
        },
        {
          text: "Fecha entrega",
          value: "fechaEntrega",
          align: "center",
          class: "column",
        },
        {
          text: "Adjunto",
          value: "archivo",
          align: "center",
          class: "column",
        },
        {
          text: "Acciones",
          value: "acciones",
          align: "center",
          class: "column",
          sortable: false,
        },
      ],
      headers1: [
        {
          text: "ID",
          value: "id",
          align: "center",
          class: "column",
        },
        {
          text: "Concepto",
          value: "concepto",
          align: "center",
          class: "column",
        },
        {
          text: "Cantidad",
          value: "cantidad",
          align: "center",
          class: "column",
        },
        {
          text: "Presupuesto",
          value: "presupuesto",
          align: "center",
          class: "column",
        },
        {
          text: "Fecha",
          value: "fecha",
          align: "center",
          class: "column",
        },
        {
          text: "Empresa",
          value: "empresa",
          align: "center",
          class: "column",
        },
        {
          text: "Detalle técnico",
          value: "expecificaciones",
          align: "center",
          class: "column",
        },
        {
          text: "Observaciones",
          value: "observaciones",
          align: "center",
          class: "column",
        },
        {
          text: "Asunto",
          value: "asunto",
          align: "center",
          class: "column",
        },
        {
          text: "Acciones",
          value: "actions",
          align: "center",
          class: "column",
          sortable: false,
        },
      ],
      defaultItem: {
        id: "",
        concepto: "",
        cantidad: "",
        expecificaciones: "",
        observaciones: "",
      },
      editedIndex: -1,
      editedItem: {
        id: "",
        concepto: "",
        cantidad: "",
        presupuesto: "",
        fecha: "",
        empresa: "",
        expecificaciones: "",
        observaciones: "",
      },
    };
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Crear Proceso" : "Editar Aplicacion";
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  mounted() {
    this.obtenerApps();
    console.log("este es el archivo", this.getFile);
  },

  methods: {
    viewImage(rutaImg) {
      window.open(rutaImg, "_blank");
    },
    // Metodo para obtener las aplicaciones
    obtenerApps() {
      axios
        .get(
          `${env.endpoint}user/procesos?idUser=${localStorage.getItem("id")}`
        )
        .then((res) => {
          this.apps = res.data;

          this.apps = this.apps.map((proceso) => {
            proceso.infofrase = proceso.infoProceso
              .map((element) => element.concepto)
              .join(", ");
            proceso.loading = false; // Añadir estado de loading para cada proceso
            return proceso;
          });
          this.apps = this.apps.map((proceso) => {
            proceso.empresa = [
              ...new Set(proceso.infoProceso.map((e) => e.empresa)),
            ].join(", ");
            return proceso;
          });
        });
    },

    // Método para marcar compra como realizada
    marcarCompraRealizada(item) {
      swal({
        title: "Marcar compra como realizada",
        text: "¿Estás seguro de que deseas marcar esta compra como realizada?",
        icon: "warning",
        buttons: ["Cancelar", "Confirmar"],
        dangerMode: false,
      }).then((willConfirm) => {
        if (willConfirm) {
          // Activar loading en el botón
          this.$set(item, "loading", true);

          // Mostrar overlay global
          this.showGlobalOverlay("Procesando actualización...");

          const formData = new FormData();
          formData.append("idProceso", item.idProceso);
          formData.append("estado", 8); // Estado 8 = Compra Realizada
          formData.append("idUser", localStorage.getItem("id"));

          axios
            .post(`${env.endpoint}user/actualizarEstadoProceso`, formData)
            .then((res) => {
              // Actualizar mensaje del overlay
              this.showGlobalOverlay("Actualizando datos...");

              if (res.data.success) {
                // Actualizar el estado localmente
                item.estado = "8";

                swal(
                  "¡Éxito!",
                  "La compra ha sido marcada como realizada",
                  "success"
                );

                // Refrescar la lista de procesos
                this.obtenerApps();
              } else {
                swal(
                  "Error",
                  "No se pudo actualizar el estado del proceso",
                  "error"
                );
              }
            })
            .catch((error) => {
              console.error("Error al actualizar estado:", error);
              swal(
                "Error",
                "Ha ocurrido un error al actualizar el estado. Intente de nuevo.",
                "error"
              );
            })
            .finally(() => {
              // Desactivar loading y cerrar overlay
              this.$set(item, "loading", false);
              this.hideGlobalOverlay();
            });
        }
      });
    },

    // Método para abrir el diálogo de observación
    agregarObservacion(item) {
      this.procesoSeleccionado = item;
      this.nuevaObservacion = "";
      this.dialogObservacion = true;
    },

    // Método para cerrar el diálogo de observación
    cerrarObservacion() {
      this.dialogObservacion = false;
      this.nuevaObservacion = "";
      this.procesoSeleccionado = null;
    },

    // Método para guardar la observación
    guardarObservacion() {
      if (!this.nuevaObservacion || this.nuevaObservacion.trim() === "") {
        swal("Error", "Debes escribir una observación", "error");
        return;
      }

      const formData = new FormData();
      formData.append("idProceso", this.procesoSeleccionado.idProceso);
      formData.append("observacion", this.nuevaObservacion.trim());
      formData.append("idUser", localStorage.getItem("id"));
      formData.append("idRol", "3");

      swal({
        title: "Agregar observación",
        text: "¿Estás seguro de que deseas agregar esta observación?",
        icon: "info",
        buttons: ["Cancelar", "Confirmar"],
        dangerMode: false,
      }).then((willConfirm) => {
        if (willConfirm) {
          axios
            .post(`${env.endpoint}user/agregarObservacionProceso`, formData)
            .then((res) => {
              if (res.data.success) {
                swal(
                  "¡Éxito!",
                  "La observación ha sido agregada correctamente",
                  "success"
                );
                this.cerrarObservacion();
                this.obtenerApps(); // Refrescar la lista de procesos
              } else {
                swal("Error", "No se pudo agregar la observación", "error");
              }
            })
            .catch((error) => {
              console.error("Error al agregar observación:", error);
              swal(
                "Error",
                "Ha ocurrido un error al agregar la observación. Intente de nuevo.",
                "error"
              );
            });
        }
      });
    },

    /**
     * Metodo para agregar fila de la tabla en la modal
     */
    editItem(item) {
      this.editedIndex = this.apps1.indexOf(item);
      // console.log("el valor de editar es:", item)
      this.editedItem = Object.assign({}, item);
      // console.log("el valor de  ", this.editedIndex)
      // console.log("el valor de editedItem", this.editedItem)
      this.dialog = true;
    },

    async submitUpload() {
      try {
        if (!this.selectedFile || this.selectedFile.length === 0) {
          alert("Por favor, selecciona al menos un archivo.");
          return;
        }
        if (this.selectedFile.length > 5) {
          alert("Solo puedes subir hasta 5 archivos.");
          return;
        }
        const formData = new FormData();
        this.selectedFile.forEach((file) => {
          formData.append("files[]", file);
        });
        await axios
          .post(
            // "http://localhost/compras/archivos/uploadAreaProcesos.php",
            // formData
            "http://localhost:8787/compras/archivos/upload.php",
            formData
          )
          .then((res) => {
            if (res.data.status === "success") {
              this.getFile = res.data.paths || res.data.path;
              console.log(this.getFile);
              swal("¡Archivos cargados correctamente!", {
                icon: "success",
              });
              return this.getFile;
            } else {
              alert(res.data.message || "Error al cargar los archivos");
            }
          });
      } catch (error) {
        console.error("Error al cargar los archivos:", error);
        alert("Hubo un error al cargar los archivos");
      } finally {
        this.selectedFile = [];
      }
    },

    /**
     * Metodo para cerrar la modal
     */
    close() {
      this.dialog = false;
      this.dialogPdf = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        // Al cerrar, desbloquear empresa
        this.empresaFija = "";
      }, 300);
    },

    cargartabla(cerrar = true) {
      // Solo cerrar el modal, no agregar proceso extra
      this.close();
      // Al cerrar, desbloquear empresa para el siguiente proceso
      this.empresaFija = "";
    },
    cargarProcesoYContinuar() {
      // Bloquear empresa después del primer proceso
      if (this.apps1.length === 0 && this.editedItem.empresa) {
        this.empresaFija = this.editedItem.empresa;
      }
      this.contadorTabla++;
      const nuevoProceso = Object.assign({}, this.editedItem);
      nuevoProceso.id = this.contadorTabla;
      // Forzar empresa fija en los siguientes procesos
      if (this.empresaFija) {
        nuevoProceso.empresa = this.empresaFija;
      }
      this.apps1.push(nuevoProceso);
      this.estadoTabla = true;
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedItem.empresa = this.empresaFija;
    },
    pdfProcesos(item) {
      this.editedIndex = this.apps1.indexOf(item);
      this.editedItem = Object.assign({}, item);
      console.log(this.editedItem);
      this.dialogPdf = true;
    },
    deleteItem(item) {
      swal({
        title: "Este registro sera eliminado permanentemente.",
        text: "Una vez eliminado no se podra recuperar.",
        icon: "warning",
        buttons: ["Cancelar", true],
        dangerMode: true,
      });
      const posicion = this.apps1.indexOf(item);
      // console.log("el valor de editar es:", item)
      this.apps1.splice(posicion, 1).then((willDelete) => {
        if (willDelete) {
          axios
            .get(`${env.endpoint}user/delete_config?id=${item.id}`)
            .then((res) => {
              swal("Registro eliminado con exito!", {
                icon: "success",
              });
            })
            .then((otherProcess) => {
              this.obtenerApps1();
            })
            .catch((error) => {
              this.text =
                "Ha ocurrido un error, intente de nuevo. Si el problema persiste comuníquese con el área de sistemas";
            });
        } else {
          swal("Proceso de eliminacion cancelado");
        }
      });
    },
    /**
     * Metodo para guardar
     */
    Enviar() {
      // const enviarTodo = JSON.stringify(this.apps1);
      console.log(this.selectedFile);
      const formData = new FormData();

      formData.append("info", JSON.stringify(this.apps1));
      formData.append("idUser", localStorage.getItem("id"));
      if (this.selectedFile && this.selectedFile.length > 0) {
        this.selectedFile.forEach((file) => {
          formData.append("files[]", file);
        });
      }
      swal({
        title: "Se enviará los procesos.",
        text: "¿Estás seguro que deseas enviar?",
        icon: "warning",
        buttons: ["Cancelar", true],
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          // Mostrar estado de carga
          swal({
            title: "Cargando...",
            text: "Enviando los datos, por favor espera.",
            icon: "info",
            buttons: false,
            closeOnClickOutside: false,
            closeOnEsc: false,
            timer: false,
          });

          axios
            .post(`${env.endpoint}user/createProceso`, formData)
            .then((res) => {
              // Al enviar con éxito, mostrar alerta de éxito
              swal("Se ha enviado con éxito!", {
                icon: "success",
              });
            })
            .catch((error) => {
              // En caso de error, mostrar mensaje de error
              swal("Ha ocurrido un error, intente de nuevo.", {
                icon: "error",
              });
            })
            .finally(() => {
              // Resetear datos y estado de la tabla
              this.apps1 = [];
              this.estadoTabla = false;
              this.obtenerApps();
              this.close();
              this.contadorTabla = 0;
            });
        } else {
          swal("Proceso de envío ha sido cancelado");
        }
      });
    },

    downloadExcel() {
      const reportes = [];
      try {
        for (let i = 0; i < this.apps.length; i++) {
          const proceso = this.apps[i];
          if (proceso.infoProceso && Array.isArray(proceso.infoProceso)) {
            for (let j = 0; j < proceso.infoProceso.length; j++) {
              const info = proceso.infoProceso[j];
              const item = {};
              item.ID = proceso.idProceso;
              item.Director = proceso.nombre;
              item.Cedula = proceso.cedula;
              item.Correo = proceso.correo;
              item.Area = proceso.nombreArea;
              item.Fecha_creacion = proceso.fechaCreacion;
              item.Fecha_entrega = proceso.fechaEntrega;

              if (proceso.estado === "1") {
                item.Estado = "Gerencia";
              } else if (proceso.estado === "2") {
                item.Estado = "Compras";
              } else if (proceso.estado === "3") {
                item.Estado = "Proveedores";
              } else if (proceso.estado === "4") {
                item.Estado = "Pendiente aprobación director area";
              } else if (proceso.estado === "5") {
                item.Estado = "Pendiente aprobación direccion financiera";
              } else if (proceso.estado === "6") {
                item.Estado = "Pendiente aprobación gerencia";
              } else if (proceso.estado === "7") {
                item.Estado = "Realizar compra";
              } else if (proceso.estado === "8") {
                item.Estado = "Compra realizada";
              }
              // Extraer datos anidados
              item.Asunto = info.asunto || "";
              item.Cantidad = info.cantidad || "";
              item.Concepto = info.concepto || "";
              item.Especificaciones = info.expecificaciones || "";
              item.Fecha = info.fecha || "";
              item.Empresa = info.Empresa || "";
              item.Observaciones = info.observaciones || "";
              item.Presupuesto = info.presupuesto || "";
              reportes.push(item);
            }
          } else {
            const item = {};
            item.ID = proceso.idProceso;
            item.Director = proceso.nombre;
            item.Cedula = proceso.cedula;
            item.Correo = proceso.correo;
            item.Area = proceso.nombreArea;
            item.Fecha_creacion = proceso.fechaCreacion;
            item.Fecha_entrega = proceso.fechaEntrega;

            if (proceso.estado === "1") {
              item.Estado = "Gerencia";
            } else if (proceso.estado === "2") {
              item.Estado = "Compras";
            } else if (proceso.estado === "3") {
              item.Estado = "Proveedores";
            } else if (proceso.estado === "4") {
              item.Estado = "Pendiente aprobación director area";
            } else if (proceso.estado === "5") {
              item.Estado = "Pendiente aprobación ";
            } else if (proceso.estado === "6") {
              item.Estado = "Pendiente aprobación gerencia";
            } else if (proceso.estado === "7") {
              item.Estado = "Realizar compra";
            } else if (proceso.estado === "8") {
              item.Estado = "Compra realizada";
            }
            // Extraer datos anidados
            item.Asunto = "";
            item.Cantidad = "";
            item.Concepto = "";
            item.Especificaciones = "";
            item.Fecha = "";
            item.Empresa = "";
            item.Observaciones = "";
            item.Presupuesto = "";
            reportes.push(item);
          }
        }
      } catch (error) {
        console.log(error);
      }
      const data = XLSX.utils.json_to_sheet(reportes);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, data, "data");
      XLSX.writeFile(wb, `ReporteComprasDirector.xlsx`);
    },

    esImagen(archivo) {
      return /\.(jpg|jpeg|png|gif)$/i.test(archivo);
    },
    nombreArchivo(archivo) {
      return archivo.split("/").pop();
    },
    // Formateo con separador de miles (punto) y decimales para presupuesto
    formatearNumero(campo, event) {
      let valor;
      if (typeof event === "string") {
        valor = event;
      } else if (event && event.target && event.target.value !== undefined) {
        valor = event.target.value;
      } else {
        valor = this.editedItem[campo] || "";
      }

      if (!valor || valor.trim() === "") {
        this.editedItem[campo] = "";
        return;
      }

      // ✅ NUEVO: Manejar decimales para el campo presupuesto
      if (campo === "presupuesto") {
        // Separar parte entera y decimal
        let partes = valor.split(",");
        let parteEntera = partes[0] || "";
        let parteDecimal = partes[1] || "";

        // Limpiar parte entera (solo números)
        parteEntera = parteEntera.replace(/[^0-9]/g, "");

        // Limitar parte decimal a 2 dígitos
        if (parteDecimal.length > 2) {
          parteDecimal = parteDecimal.substring(0, 2);
        }

        // Formatear parte entera con separadores de miles (puntos)
        if (parteEntera.length > 3) {
          // Eliminar puntos existentes primero
          parteEntera = parteEntera.replace(/\./g, "");
          // Formatear cada 3 dígitos desde la derecha
          parteEntera = parteEntera.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        }

        // Construir valor final
        let valorFinal = parteEntera;
        if (parteDecimal) {
          valorFinal += "," + parteDecimal;
        }

        this.editedItem[campo] = valorFinal;
      } else {
        // ✅ Código original para otros campos (cantidad, etc.)
        const soloDigitos = valor.replace(/[^0-9]/g, "");
        const conMiles = soloDigitos.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        this.editedItem[campo] = conMiles;
      }
    },
    abrirArchivo(archivo) {
      window.open(archivo, "_blank");
    },
    verArchivos(item) {
      // Soporta múltiples archivos separados por coma o array
      let archivos = [];
      if (Array.isArray(item.ruta_img)) {
        archivos = item.ruta_img;
      } else if (
        typeof item.ruta_img === "string" &&
        item.ruta_img.includes(",")
      ) {
        archivos = item.ruta_img
          .split(",")
          .map((a) => a.trim())
          .filter(Boolean);
      } else if (item.ruta_img) {
        archivos = [item.ruta_img];
      }
      this.archivosModal = archivos;
      this.dialogArchivos = true;
    },
    // Overlay global montado en body
    showGlobalOverlay(mensaje) {
      this.hideGlobalOverlay();
      const overlay = document.createElement("div");
      overlay.id = "global-loading-overlay";
      overlay.style.position = "fixed";
      overlay.style.top = "0";
      overlay.style.left = "0";
      overlay.style.width = "100%";
      overlay.style.height = "100%";
      overlay.style.background = "rgba(0,0,0,0.6)";
      overlay.style.zIndex = "9999";
      overlay.style.display = "flex";
      overlay.style.alignItems = "center";
      overlay.style.justifyContent = "center";
      overlay.style.backdropFilter = "blur(2px)";

      const card = document.createElement("div");
      card.style.background =
        "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)";
      card.style.borderRadius = "12px";
      card.style.padding = "32px 40px";
      card.style.minWidth = "320px";
      card.style.maxWidth = "90%";
      card.style.boxShadow =
        "0 20px 60px rgba(0,0,0,0.3), 0 0 0 1px rgba(255,255,255,0.1)";
      card.style.display = "flex";
      card.style.flexDirection = "column";
      card.style.alignItems = "center";
      card.style.textAlign = "center";
      card.style.border = "1px solid rgba(255,255,255,0.2)";
      card.style.position = "relative";
      card.style.overflow = "hidden";

      // Efecto de brillo animado
      const shine = document.createElement("div");
      shine.style.position = "absolute";
      shine.style.top = "0";
      shine.style.left = "-100%";
      shine.style.width = "100%";
      shine.style.height = "100%";
      shine.style.background =
        "linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent)";
      shine.style.animation = "shine 2s ease-in-out infinite";
      card.appendChild(shine);

      // Contenedor del spinner
      const spinnerContainer = document.createElement("div");
      spinnerContainer.style.position = "relative";
      spinnerContainer.style.marginBottom = "20px";

      // Spinner principal
      const spinner = document.createElement("div");
      spinner.style.border = "4px solid rgba(25,118,210,0.1)";
      spinner.style.borderTop = "4px solid #1976d2";
      spinner.style.borderRadius = "50%";
      spinner.style.width = "60px";
      spinner.style.height = "60px";
      spinner.style.animation = "spin 1s linear infinite";
      spinner.style.position = "relative";
      spinner.style.zIndex = "2";

      // Spinner secundario (más pequeño)
      const spinner2 = document.createElement("div");
      spinner2.style.border = "3px solid rgba(76,175,80,0.1)";
      spinner2.style.borderTop = "3px solid #4caf50";
      spinner2.style.borderRadius = "50%";
      spinner2.style.width = "40px";
      spinner2.style.height = "40px";
      spinner2.style.animation = "spin 1.5s linear infinite reverse";
      spinner2.style.position = "absolute";
      spinner2.style.top = "10px";
      spinner2.style.left = "10px";
      spinner2.style.zIndex = "1";

      spinnerContainer.appendChild(spinner);
      spinnerContainer.appendChild(spinner2);

      // Texto principal
      const text = document.createElement("div");
      text.style.fontSize = "16px";
      text.style.fontWeight = "600";
      text.style.color = "#424242";
      text.style.marginBottom = "8px";
      text.style.letterSpacing = "0.2px";
      text.style.fontFamily =
        "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif";
      text.textContent = mensaje || "Procesando...";

      // Texto secundario
      const subText = document.createElement("div");
      subText.style.fontSize = "13px";
      subText.style.fontWeight = "400";
      subText.style.color = "#757575";
      subText.style.opacity = "0.9";
      subText.style.fontFamily =
        "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif";
      subText.textContent = "Por favor espere un momento";

      card.appendChild(spinnerContainer);
      card.appendChild(text);
      card.appendChild(subText);
      overlay.appendChild(card);
      document.body.appendChild(overlay);

      // Agregar estilos de animación si no existen
      if (!document.getElementById("loading-animations")) {
        const style = document.createElement("style");
        style.id = "loading-animations";
        style.textContent = `
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          @keyframes shine {
            0% { left: -100%; }
            100% { left: 100%; }
          }
        `;
        document.head.appendChild(style);
      }
    },

    hideGlobalOverlay() {
      const overlay = document.getElementById("global-loading-overlay");
      if (overlay && overlay.parentNode) {
        overlay.parentNode.removeChild(overlay);
      }
    },
    // Método para permitir solo números (sin comas ni puntos) en el campo presupuesto
    soloNumeros(event) {
      const char = String.fromCharCode(event.which);
      if (!/[0-9]/.test(char)) {
        event.preventDefault();
      }
    },
    // Método para permitir solo números enteros en el campo cantidad
    soloNumerosCantidad(event) {
      const char = String.fromCharCode(event.which);
      if (!/[0-9]/.test(char)) {
        event.preventDefault();
      }
    },
    // Método auxiliar para detectar teclas de control
    esTeclaControl(event) {
      const controlKeys = [
        8, 9, 13, 16, 17, 18, 19, 20, 27, 33, 34, 35, 36, 37, 38, 39, 40, 45,
        46,
      ];
      return (
        controlKeys.includes(event.keyCode) ||
        (event.ctrlKey && [65, 67, 86, 88, 90].includes(event.keyCode))
      );
    },
    // Método para permitir números con decimales (coma como separador decimal)
    soloNumerosConDecimales(event) {
      const char = String.fromCharCode(event.which);
      const currentValue = event.target.value;

      // Permitir números, comas (solo una) y teclas de control
      if (!/[0-9,]/.test(char) && !this.esTeclaControl(event)) {
        event.preventDefault();
        return;
      }

      // Si es coma, verificar que no haya ya una coma
      if (char === ",") {
        if (currentValue.includes(",")) {
          event.preventDefault();
        }
      }
    },
  },
};
</script>

<style scoped>
/* ===== DISEÑO MODERNO Y ELEGANTE ===== */
.procesos-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
  padding: 1.5rem;
}

.unified-container {
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  background: white;
  border-radius: 0;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

/* ===== HEADER SECTION ===== */
.header-section {
  background: linear-gradient(135deg, #3b82f6 0%, #1e40af 100%);
  padding: 2rem;
  color: white;
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
}

.header-section::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    45deg,
    rgba(255, 255, 255, 0.1) 0%,
    transparent 50%,
    rgba(255, 255, 255, 0.05) 100%
  );
  pointer-events: none;
}

.title-section {
  display: flex;
  align-items: center;
  gap: 1.5rem;
  position: relative;
  z-index: 2;
}

.title-icon {
  width: 60px;
  height: 60px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
}

.title-text {
  flex: 1;
}

.main-title {
  font-size: 1.8rem;
  font-weight: 700;
  margin: 0 0 0.5rem 0;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  letter-spacing: 0.5px;
}

.subtitle {
  font-size: 1rem;
  margin: 0;
  opacity: 0.9;
  font-weight: 400;
}

.header-actions {
  position: relative;
  z-index: 2;
}

.export-btn {
  background: rgba(255, 255, 255, 0.2) !important;
  color: white !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
  backdrop-filter: blur(10px) !important;
  transition: all 0.3s ease !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0.5px !important;
}

.export-btn:hover {
  background: rgba(255, 255, 255, 0.3) !important;
  transform: translateY(-2px) !important;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2) !important;
}

/* ===== SEARCH SECTION ===== */
.search-section {
  padding: 1.5rem 2rem;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1.5rem;
  flex-wrap: wrap;
}

.search-card {
  flex: 1;
  max-width: 500px;
}

.search-field {
  background: white !important;
  border-radius: 12px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05) !important;
}

.create-btn-container {
  flex-shrink: 0;
}

.create-btn {
  background: linear-gradient(135deg, #3b82f6 0%, #1e40af 100%) !important;
  color: white !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0.5px !important;
  box-shadow: 0 4px 15px rgba(59, 130, 246, 0.4) !important;
  transition: all 0.3s ease !important;
}

.create-btn:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 8px 25px rgba(59, 130, 246, 0.6) !important;
}

/* ===== TABLE SECTION ===== */
.table-section {
  padding: 0;
  background: white;
}

.table-card {
  padding: 0;
  background: white;
  overflow-x: auto;
  width: 100%;
}

/* ===== DISEÑO MINIMALISTA ELEGANTE PARA TABLA ===== */
.modern-table {
  background: white !important;
  border-radius: 0 !important;
  overflow: visible !important;
  box-shadow: none !important;
  border: none !important;
  width: 100% !important;
  min-width: 800px; /* Ancho mínimo para forzar scroll si es necesario */
}

.modern-table >>> .v-data-table__wrapper {
  border-radius: 0 !important;
  overflow-x: scroll !important; /* Cambiar a scroll para que siempre aparezca */
  overflow-y: visible !important;
  background: white !important;
  width: 100% !important;
  max-width: 100%;
}

/* Estilos para el scrollbar horizontal siempre visible */
.modern-table >>> .v-data-table__wrapper::-webkit-scrollbar {
  height: 12px !important; /* Más alto para mejor visibilidad */
  display: block !important;
  -webkit-appearance: none;
}

.modern-table >>> .v-data-table__wrapper::-webkit-scrollbar-track {
  background: #e5e7eb !important; /* Más visible */
  border-radius: 6px !important;
  margin: 0 10px;
}

.modern-table >>> .v-data-table__wrapper::-webkit-scrollbar-thumb {
  background: #64748b !important; /* Más oscuro para mejor visibilidad */
  border-radius: 6px !important;
  border: 2px solid #e5e7eb;
}

.modern-table >>> .v-data-table__wrapper::-webkit-scrollbar-thumb:hover {
  background: #475569 !important; /* Aún más oscuro al hover */
}

/* Para Firefox */
.modern-table >>> .v-data-table__wrapper {
  scrollbar-width: thin;
  scrollbar-color: #64748b #e5e7eb;
}

.modern-table >>> .v-data-table-header {
  background: white !important;
  border-bottom: 1px solid #e5e7eb !important;
  position: relative !important;
}

.modern-table >>> .v-data-table-header th {
  color: #374151 !important;
  font-weight: 600 !important;
  font-size: 0.9rem !important;
  text-transform: uppercase !important;
  letter-spacing: 0.8px !important;
  padding: 1.25rem 1rem !important;
  background: transparent !important;
  border-bottom: 2px solid #f3f4f6 !important;
}

.modern-table >>> .v-data-table__wrapper table tbody tr {
  transition: all 0.2s ease !important;
  border-bottom: 1px solid #f9fafb !important;
}

.modern-table >>> .v-data-table__wrapper table tbody tr:nth-child(even) {
  background: #fafbfc !important;
}

.modern-table >>> .v-data-table__wrapper table tbody tr:hover {
  background: #f8fafc !important;
  transform: translateY(-1px) !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05) !important;
}

.modern-table >>> .v-data-table__wrapper table tbody tr td {
  color: #1f2937 !important;
  font-weight: 400 !important;
  border-bottom: 1px solid #f3f4f6 !important;
  padding: 1rem 0.75rem !important;
  font-size: 0.875rem !important;
  line-height: 1.5 !important;
  vertical-align: middle !important;
  white-space: nowrap !important;
}

.modern-table >>> .v-data-table__wrapper table thead tr th {
  padding: 1rem 0.75rem !important;
  font-size: 0.85rem !important;
}

/* ===== ICONOS DE ACCIONES MODERNOS ===== */
.action-icons {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  justify-content: center;
}

.action-group {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.action-icon {
  font-size: 20px !important;
  cursor: pointer !important;
  transition: all 0.3s ease !important;
  padding: 4px !important;
  border-radius: 4px !important;
}

.view-icon {
  color: #3b82f6 !important;
}

.view-icon:hover {
  color: #1d4ed8 !important;
  transform: scale(1.1) !important;
}

.approve-icon {
  color: #059669 !important;
}

.approve-icon:hover {
  color: #047857 !important;
  transform: scale(1.1) !important;
}

.comment-icon {
  color: #3b82f6 !important;
}

.comment-icon:hover {
  color: #1d4ed8 !important;
  transform: scale(1.1) !important;
}

.edit-icon {
  color: #059669 !important;
}

.edit-icon:hover {
  color: #047857 !important;
  transform: scale(1.1) !important;
}

.delete-icon {
  color: #dc2626 !important;
}

.delete-icon:hover {
  color: #b91c1c !important;
  transform: scale(1.1) !important;
}

.pdf-icon {
  color: #dc2626 !important;
  font-size: 20px !important;
  cursor: pointer !important;
  transition: all 0.3s ease !important;
  padding: 4px !important;
}

.pdf-icon:hover {
  color: #b91c1c !important;
  transform: scale(1.1) !important;
}

/* ===== FOOTER DE TABLA ===== */
.modern-table >>> .v-data-footer {
  background: white !important;
  border-top: 1px solid #e5e7eb !important;
  padding: 1.25rem !important;
  border-radius: 0 !important;
}

.modern-table >>> .v-data-footer__select {
  color: #6b7280 !important;
  font-weight: 500 !important;
  font-size: 0.9rem !important;
}

.modern-table >>> .v-data-footer__pagination {
  color: #6b7280 !important;
  font-weight: 500 !important;
  font-size: 0.9rem !important;
}

.modern-table >>> .v-data-footer .v-btn {
  background: #f3f4f6 !important;
  color: #374151 !important;
  border: 1px solid #e5e7eb !important;
  border-radius: 6px !important;
  transition: all 0.2s ease !important;
  font-size: 0.9rem !important;
  padding: 0.6rem 0.9rem !important;
  font-weight: 500 !important;
}

.modern-table >>> .v-data-footer .v-btn:hover {
  background: #e5e7eb !important;
  border-color: #d1d5db !important;
  transform: translateY(-1px) !important;
}

/* ===== SEND SECTION ===== */
.send-section {
  padding: 2rem;
  background: #f8fafc;
  border-top: 1px solid #e2e8f0;
  display: flex;
  justify-content: center;
}

.send-btn {
  background: linear-gradient(135deg, #059669 0%, #047857 100%) !important;
  color: white !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0.5px !important;
  box-shadow: 0 4px 15px rgba(5, 150, 105, 0.4) !important;
  transition: all 0.3s ease !important;
  min-width: 200px !important;
}

.send-btn:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 8px 25px rgba(5, 150, 105, 0.6) !important;
}

.send-btn:disabled {
  background: #9ca3af !important;
  color: #6b7280 !important;
  box-shadow: none !important;
  transform: none !important;
}

/* ===== SNACKBAR MODERNO ===== */
.modern-snackbar {
  border-radius: 8px !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2) !important;
}

/* ===== ESTILOS PARA MODAL ===== */
.archivo-preview-modal-director {
  cursor: pointer;
  width: 160px;
  height: 160px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8fafc;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  border: 1px solid #e2e8f0;
  transition: all 0.3s ease;
}

.archivo-preview-modal-director:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

.archivo-nombre-modal-director {
  font-size: 0.8rem;
  word-break: break-all;
  max-width: 160px;
  text-align: center;
  margin-bottom: 12px;
  color: #64748b;
  font-weight: 500;
}

/* ===== RESPONSIVE DESIGN ===== */

/* Laptops grandes (1920px y más) - Full HD */
@media (min-width: 1920px) {
  .procesos-container {
    padding: 2rem;
  }

  .header-section {
    padding: 2rem;
  }

  .search-section {
    padding: 1.5rem 2rem;
  }

  .modern-table >>> .v-data-table__wrapper table tbody tr td {
    padding: 1rem 1rem !important;
    font-size: 0.875rem !important;
  }

  .modern-table >>> .v-data-table__wrapper table thead tr th {
    padding: 1rem 1rem !important;
    font-size: 0.85rem !important;
  }
}

/* Laptops estándar (1366px - 1919px) */
@media (min-width: 1366px) and (max-width: 1919px) {
  .procesos-container {
    padding: 1.5rem;
  }

  .header-section {
    padding: 2rem;
  }

  .search-section {
    padding: 1.5rem 2rem;
  }

  .modern-table >>> .v-data-table__wrapper table tbody tr td {
    padding: 1rem 0.5rem !important;
    font-size: 0.85rem !important;
  }

  .modern-table >>> .v-data-table__wrapper table thead tr th {
    padding: 1rem 0.5rem !important;
    font-size: 0.8rem !important;
  }
}

/* Laptops medianas (1024px - 1365px) */
@media (min-width: 1024px) and (max-width: 1365px) {
  .procesos-container {
    padding: 1rem;
  }

  .header-section {
    padding: 1.5rem;
  }

  .search-section {
    padding: 1.25rem 1.5rem;
  }

  .main-title {
    font-size: 1.5rem;
  }

  .subtitle {
    font-size: 0.9rem;
  }

  .modern-table >>> .v-data-table__wrapper table tbody tr td {
    padding: 0.875rem 0.5rem !important;
    font-size: 0.8rem !important;
  }

  .modern-table >>> .v-data-table__wrapper table thead tr th {
    padding: 0.875rem 0.5rem !important;
    font-size: 0.75rem !important;
  }
}

/* Tablets (768px - 1023px) */
@media (max-width: 1023px) {
  .procesos-container {
    padding: 1rem;
  }

  .header-section {
    padding: 1.5rem;
    flex-direction: column;
    gap: 1rem;
    text-align: center;
  }

  .title-section {
    flex-direction: column;
    text-align: center;
    gap: 1rem;
  }

  .main-title {
    font-size: 1.4rem;
  }

  .search-section {
    padding: 1.25rem;
    flex-direction: column;
    gap: 1rem;
  }

  .search-card {
    max-width: 100%;
  }

  .table-card {
    overflow-x: auto; /* Mantener scroll horizontal */
  }

  .modern-table >>> .v-data-table__wrapper {
    overflow-x: auto !important; /* Mantener scroll horizontal */
  }
}

/* Móviles (menos de 768px) */
@media (max-width: 768px) {
  .procesos-container {
    padding: 0.75rem;
  }

  .unified-container {
    margin: 0;
    border-radius: 0;
    width: 100%;
  }

  .header-section {
    padding: 1.25rem;
    flex-direction: column;
    gap: 1rem;
    text-align: center;
  }

  .title-section {
    flex-direction: column;
    text-align: center;
    gap: 0.75rem;
  }

  .title-icon {
    width: 50px;
    height: 50px;
  }

  .main-title {
    font-size: 1.3rem;
  }

  .subtitle {
    font-size: 0.85rem;
  }

  .search-section {
    padding: 1rem;
    flex-direction: column;
    gap: 1rem;
  }

  .search-card {
    max-width: 100%;
  }

  .create-btn {
    width: 100% !important;
  }

  .export-btn {
    width: 100% !important;
    margin-top: 0.5rem;
  }

  .table-card {
    overflow-x: auto; /* Mantener scroll horizontal */
  }

  .modern-table >>> .v-data-table__wrapper {
    overflow-x: auto !important; /* Mantener scroll horizontal */
  }

  .send-section {
    padding: 1.25rem;
  }
}

/* Fuerza scrim oscuro solo para este componente usando la clase agregada al overlay */
.scrim-opaco-crear .v-overlay__scrim {
  background: rgba(0, 0, 0, 0.8) !important;
}
</style>
